/**
 * IconTile — Connecteam-style colored rounded-square icon wrapper.
 *
 * Usage:
 *   import { IconTile } from '../components/ui/IconTile';
 *   <IconTile icon={Receipt} tint="#ef4444" />          // default 32px
 *   <IconTile icon={Calendar} tint="#f97316" size={28} />
 *
 * Why: every nav/sidebar/page-header/stat-card icon in the app shares
 * one visual treatment — a colored rounded background with a white
 * outlined icon — so the whole product feels cohesive.
 */
export const IconTile = ({
  icon: Icon,
  tint = '#0073ea',
  size = 32,
  radius,
  iconSize,
  strokeWidth = 2.25,
  style = {},
  className,
  'data-testid': testId,
}) => {
  const sz = Number(size);
  return (
    <span
      className={className}
      data-testid={testId}
      style={{
        width: sz,
        height: sz,
        borderRadius: radius ?? Math.round(sz * 0.28),
        background: tint,
        color: '#fff',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        ...style,
      }}
    >
      <Icon size={iconSize ?? Math.round(sz * 0.55)} strokeWidth={strokeWidth} />
    </span>
  );
};

// Re-export the central tint palette so every page picks from the same set
// (matches the sidebar tints in Layout.js).
export const TINT = {
  dashboard:   '#0073ea',
  employees:   '#a855f7',
  timeClock:   '#3b82f6',
  customers:   '#ec4899',
  scheduling:  '#f97316',
  inspections: '#10b981',
  invoices:    '#22c55e',
  expenses:    '#ef4444',
  mileage:     '#0ea5e9',
  calculator:  '#f59e0b',
  inventory:   '#8b5cf6',
  settings:    '#64748b',
  about:       '#0ea5e9',
  recurring:   '#3b82f6',
  reports:     '#a855f7',
  storage:     '#0ea5e9',
  // common secondaries
  green:       '#10b981',
  yellow:      '#f59e0b',
  red:         '#ef4444',
  purple:      '#a855f7',
  blue:        '#0073ea',
  pink:        '#ec4899',
  slate:       '#64748b',
};

export default IconTile;
